import { API_URL } from '../../urls';
import { fetchTokenPending, fetchTokenSuccess, fetchTokenError } from './actions';
var jwtDecode = require('jwt-decode');

export function ensureToken() {
    return dispatch => {
        dispatch(fetchTokenPending());
        let token = localStorage.getItem('_TOKEN_AUTH');
        var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
        var request = {
          requestUri: API_URL + "Users/Default.RefreshToken",
          method: 'POST',
          headers: headers,
          data: {}
        };
        window.odatajs.oData.request(
          request,
          (data, response) => {
            localStorage.setItem('_TOKEN_AUTH', data.value);
            dispatch(fetchTokenSuccess(data.value));
          },
          (err) => {
            dispatch(fetchTokenError(err));
          }
        );    
    };
}

export function fetchToken() {
  return dispatch => {
    try {
      let token = localStorage.getItem('_TOKEN_AUTH');
      var decoded = jwtDecode(token);
      if(Date.now() < decoded.exp * 1000){
        dispatch(fetchTokenSuccess(token));
        return;
      }
    }
    catch(e){}
    
    ensureToken()(dispatch);
  }
}

